import { render, staticRenderFns } from "./AbstractChat.vue?vue&type=template&id=48922e76&"
import script from "./AbstractChat.vue?vue&type=script&lang=js&"
export * from "./AbstractChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports